<template>


    <span class="profile-pic position-relative">
        <v-img :src="user.picture"></v-img>

        <span class="position-absolute top-0 right-0">
            <slot name="verification-status"></slot>
        </span>
    </span>


</template>



<script setup lang="ts">
import { computed } from 'vue';
import { useUserStore } from "@/store/UserStore";

const userStore = useUserStore();
const user = computed(() => userStore.user);

</script>